export default {"src":"/_next/static/media/ready.85a679e2.svg","height":30,"width":30};